module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/29_9468f4f380ef8f0a546079c66b931a1f.jpg";